import { Navigate, Outlet } from "react-router";
import { useAuthState } from "../contexts/AuthContext";

export const AuthenticatedRoute = () => {
    const { isAuthenticated } = useAuthState();

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />
}